<div class="loadingShadow" *ngIf="showLoading==true">
    <div class="loadingContainer">
        <img src="assets/img/loading.gif" />
        <div class="loadingText">{{loadingText|async}}</div>
    </div>
</div>